<template>
  <main class="main" role="main">
    <div class="page">
      <div class="inner">
        <div class="lnb">
          <ul>
            <li><p class="home"></p></li>
            <li><p>외식 경영 관리사</p></li>
            <li><p>외식 경영 관리사 안내</p></li>
          </ul>
        </div>
        <div class="page_ttl">
          <h1 class="h1">
            <span>외식 경영 관리사 안내</span>
          </h1>
        </div>
        <div class="page_con">
          <div class="rule_list">
            <ul class="rule_list_ul">
              <li class="rule_list_li">
                <div class="rule_list_ttl">
                  <h3 class="h3">1. 목적</h3>
                </div>
                <div class="rule_list_con">
                  <p>
                    최근 트랜드가 급변하면서 노동집약적인 외식산업분야의
                    경우,<br />
                    빠른 시장변화 대응과 기업 경쟁력 제고를 위한 외식업
                    경영분야에서의 특화된 전문인력 양성 시급
                  </p>
                  <ol class="dot_big li_space">
                    <li>
                      <span class="ol_li_txt">
                        외식관련 자격증 운영을 통해 외식산업 전문가를 양성하여
                        외식산업 진흥의 기반 조성 및 경쟁력 강화
                      </span>
                    </li>
                    <li>
                      <span class="ol_li_txt">
                        NCS '외식경영분야'를 신설에 따라 산업현장의 수요에
                        부응한 직무수행능력 역량강화
                      </span>
                    </li>
                  </ol>
                </div>
              </li>
              <li class="rule_list_li">
                <div class="rule_list_ttl">
                  <h3 class="h3">2. 시험과목 및 주요내용</h3>
                </div>
                <div class="rule_list_con">
                  <div class="table">
                    <div class="row head">
                      <div class="cell fix300"><p>과목명</p></div>
                      <div class="cell"><p>세부내용</p></div>
                    </div>
                    <div class="row">
                      <div class="cell fix300"><p>외식 경영관리</p></div>
                      <div class="cell">
                        <p class="left">
                          외식경영, 점포운영관리, 창업 및 프랜차이즈 경영
                        </p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="cell fix300">
                        <p>외식 마케팅 및 서비스 관리</p>
                      </div>
                      <div class="cell">
                        <p class="left">
                          마케팅, 서비스관리, 접객서비스 교육훈련
                        </p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="cell fix300">
                        <p>외식 상품 및 생산관리</p>
                      </div>
                      <div class="cell">
                        <p class="left">메뉴관리, 생산관리, 시설관리</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="cell fix300"><p>외식 식재료관리</p></div>
                      <div class="cell">
                        <p class="left">식품구매, 원가관리, 조리과학</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="cell fix300"><p>외식 관련법규</p></div>
                      <div class="cell">
                        <p class="left">
                          식품위생학, 식품위생법, 외식산업진흥법
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li class="rule_list_li">
                <div class="rule_list_ttl">
                  <h3 class="h3">3. 시험계획</h3>
                </div>
                <div class="rule_list_con">
                  <div class="table">
                    <div class="row">
                      <div class="col head fix300">
                        <div class="cell"><p>일정</p></div>
                      </div>
                      <div class="col">
                        <div class="cell">
                          <p class="left">(사)한국외식산업협회 홈페이지 참조</p>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col head fix300">
                        <div class="cell"><p>원서접수</p></div>
                      </div>
                      <div class="col">
                        <div class="cell">
                          <p class="left">
                            시험 5일전 마감(일정에 따라 변경될 수 있음)
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col head fix300">
                        <div class="cell"><p>합격자 조회</p></div>
                      </div>
                      <div class="col">
                        <div class="cell">
                          <p class="left">
                            시험일 기준으로 7일 후 (사)한국외식산업협회 홈페이지
                            합격자조회에서 가능
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col head fix300">
                        <div class="cell"><p>합격조건</p></div>
                      </div>
                      <div class="col">
                        <div class="cell">
                          <p class="left">
                            과목별 40점이상, 평균 60점이상 (100문항, 1문항당
                            5점)
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col head fix300">
                        <div class="cell"><p>자격증 형태</p></div>
                      </div>
                      <div class="col">
                        <div class="cell">
                          <p class="left">신분증형태 1매, 증서형태 1매</p>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col head fix300">
                        <div class="cell"><p>비용</p></div>
                      </div>
                      <div class="col">
                        <div class="cell">
                          <p class="left">
                            교육비 15만원 (교재비 2만 2천원 포함)<br />
                            ※ (사)한국외식산업협회에서 인정한 지정기관에서 교육
                            대체가능<br />
                            ※ 시험비 관련 참고사항<br />
                            • 응시료 5만원<br />
                            • 자격증 발급비 1만 5천원<br />
                            • 교재 2만 2천원(선택사항)
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li class="rule_list_li">
                <div class="rule_list_ttl">
                  <h3 class="h3">4. 응시자격</h3>
                </div>
                <div class="rule_list_con">
                  <div class="table">
                    <div class="row head">
                      <div class="cell"><p>1급</p></div>
                      <div class="cell"><p>2급</p></div>
                    </div>
                    <div class="row">
                      <div class="cell">
                        <p>
                          외식산업 관련분야 5년 이상 종사자 중,
                          (사)한국외식산업협회<br />
                          또는지정기관의 외식경영관리사 1급 교육과정을 이수한 자
                        </p>
                      </div>
                      <div class="cell">
                        <p>
                          외식산업 관련분야 6개월 이상 종사자 중
                          (사)한국외식산업협회<br />
                          또는 지정기관의 외식경영관리사 2급 교육 과정을
                          이수한자
                        </p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="cell">
                        <p>
                          대학 외식관련학과 재학 이상의 학력자로 응시일 기준<br />
                          85학점 또는 5학기 이상을 이수한 자 중,
                          (사)한국외식산업협회 또는<br />
                          지정기관의 외식경영관리사 1급 교육과정을 이수한 자
                        </p>
                      </div>
                      <div class="cell">
                        <p>
                          전문대학 외식관련학과 재학 이상의 학력자로 응시일
                          기준<br />
                          15학점 또는 1학기 이상을 이수한 자 중,
                          (사)한국외식산업협회 또는<br />
                          지정기관의 외식경영관리사 2급 교육 과정을 이수한 자
                        </p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="cell">
                        <p>
                          (사)한국외식산업협회의 외식경영관리사 2급 자격을 취득
                          후,<br />
                          외식산업 관련분야에서 2년이상 근무한 자 중,
                          (사)한국외식산업협회 또는<br />
                          지정기관의 외식경영관리사 1급 교육과정을 이수한 자
                        </p>
                      </div>
                      <div class="cell">
                        <p></p>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li class="rule_list_li">
                <div class="rule_list_ttl">
                  <h3 class="h3">5. 자격정보</h3>
                </div>
                <div class="rule_list_con">
                  <div class="table">
                    <div class="row">
                      <div class="col head fix210">
                        <div class="cell"><p>기관명(자격발급기관)</p></div>
                      </div>
                      <div class="col">
                        <div class="cell">
                          <p class="left">(사)한국외식산업협회</p>
                        </div>
                      </div>
                      <div class="col head fix210">
                        <div class="cell"><p>대표자</p></div>
                      </div>
                      <div class="col">
                        <div class="cell">
                          <p class="left">윤홍근</p>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col head fix210">
                        <div class="cell"><p>자격명</p></div>
                      </div>
                      <div class="col">
                        <div class="cell">
                          <p class="left">외식경영관리사</p>
                        </div>
                      </div>
                      <div class="col head fix210">
                        <div class="cell"><p>등록번호</p></div>
                      </div>
                      <div class="col">
                        <div class="cell">
                          <p class="left">2012-0590</p>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col head fix210">
                        <div class="cell"><p>자격종류</p></div>
                      </div>
                      <div class="col">
                        <div class="cell">
                          <p class="left">등록(비공인)민간자격</p>
                        </div>
                      </div>
                      <div class="col head fix210">
                        <div class="cell"><p>홈페이지</p></div>
                      </div>
                      <div class="col">
                        <div class="cell">
                          <p class="left">www.kofsia.or.kr</p>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col head fix210">
                        <div class="cell"><p>전화번호</p></div>
                      </div>
                      <div class="col">
                        <div class="cell">
                          <p class="left">02-449-5009</p>
                        </div>
                      </div>
                      <div class="col head fix210">
                        <div class="cell"><p>이메일</p></div>
                      </div>
                      <div class="col">
                        <div class="cell">
                          <p class="left">kfia@kofsia.or.kr</p>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col head fix210">
                        <div class="cell"><p>주소</p></div>
                      </div>
                      <div class="col">
                        <div class="cell">
                          <p class="left">
                            서울특별시 서초구 강남대로 27(양재동232) aT센터
                            1101호
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col head fix210">
                        <div class="cell"><p>소비자알림사항</p></div>
                      </div>
                      <div class="col">
                        <div class="cell">
                          <p class="left">
                            1. 상기
                            <span class="blue">“외식경영관리사”</span>자격은
                            자격기본법 규정에 따라 등록한 민간자격으로,
                            <span class="blue"
                              >국가로부터 인정받은 공인자격이 아닌 등록된
                              민간자격증</span
                            >
                            입니다.<br />
                            2. 민간자격
                            <span class="blue"
                              >등록 및 공인제도에 대한 상세내용은
                              민간자격정보서비스(www.pqi.or.kr)</span
                            >의 ‘민간자격 소개’란에서 확인할 수 있습니다.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'manage-info-index'
}
</script>

<style scoped></style>
